import { observer } from "mobx-react";
import { ButtonIcon } from "../../inputs/button-icon/button-icon";
import IconDiscard from "../../icons/icon-discard/icon-discard";
import FontBody1 from "../../fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../fonts/font-props";
import { IconProps } from "../../icons/icon-props-interface";
import IconCheck from "../../icons/icon-check/icon-check";
import IconExclamation from "../../icons/icon-exclamation/icon-exclamation";
import Icon from "../../icons/icon/icon";
import { Button } from "../../inputs/button/button";
import { BUTTON_VARIANTS } from "../../inputs/button-variants";
import { ToastMessageStore } from "../toast-messages-store";
import './toast-message.scss';

export enum TOAST_VARIANTS {
    SUCCESS = 'success',
    ERROR = 'error',
}

interface IToastProps {
    toast: ToastMessageStore;
}

const ToastMessage: React.FC<IToastProps> = observer(({ toast }) => {

    const getIconComponent = (): React.FC<IconProps> => {
        switch (toast.variant) {
            case TOAST_VARIANTS.SUCCESS:
                return () => <IconCheck color="var(--color-semantic-success)" />;
            case TOAST_VARIANTS.ERROR:
                return () => <IconExclamation color="var(--color-accent-3)" />;
            default:
                throw new Error('[ToastMessage] getIconComponent - Invalid variant: ' + toast.variant);
        }
    }

    const getFontColor = (): FONT_COLOR => {
        switch (toast.variant) {
            case TOAST_VARIANTS.SUCCESS:
                return FONT_COLOR.SEMANTIC_SUCCESS;
            case TOAST_VARIANTS.ERROR:
                return FONT_COLOR.ACCENT3;
            default:
                throw new Error('[ToastMessage] getFontColor - Invalid variant: ' + toast.variant);
        }
    }

    return (
        <div className={`toast-message variant-${toast.variant}`}>
            <div className="toast-message-icon"><Icon Component={getIconComponent()} /></div>
            <div className="toast-message-content">
                <FontBody1 variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]} color={getFontColor()}>{toast.title}</FontBody1>
                <FontBody1>{toast.description}</FontBody1>
            </div>
            <div className="toast-message-buttons">
                { toast.actionButton &&
                    <Button variant={BUTTON_VARIANTS.Default} text={toast.actionButton.title} onClick={toast.actionButton.onClick} />
                }
                { toast.hasCloseButton &&
                    <ButtonIcon Component={IconDiscard} color="var(--color-neutral-3)" onClick={toast.remove} />
                }
            </div>
        </div>
    );
});

export default ToastMessage;